var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 76,
    viewBox: "0 0 73 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1897 54.3659C65.1503 66.5906 52.5582 75 38 75C17.5659 75 1 58.4341 1 38C1 17.5659 17.5659 1 38 1V6.7702L38.0013 6.77146C20.6957 6.82681 6.68341 20.8705 6.68341 38.1887C6.68341 47.4245 10.6686 55.7282 17.0112 61.4783L46.8358 31.6537L53.2778 38.0969L31.8876 59.487L41.794 69.3933C52.6035 68.1266 61.7337 61.3739 66.3302 51.9947V51.9972L71.1897 54.3659Z",
    fill: "#E1DBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8772 27.1417C40.1916 28.0298 39.4557 28.8676 38.7097 29.6953C37.96 30.5193 37.1901 31.3231 36.4052 32.1119L34.0377 34.4655C33.2502 35.2517 32.4552 36.0304 31.6602 36.809C30.8652 37.5877 30.0727 38.3689 29.2701 39.14C28.47 39.9137 27.6725 40.6898 26.8649 41.4559C25.2572 42.9956 23.6357 44.5228 21.9929 46.026C21.7777 46.2223 21.4444 46.2084 21.2469 45.9933C21.0607 45.7908 21.0657 45.4801 21.2469 45.2813C22.7501 43.6372 24.2773 42.0169 25.817 40.4093C26.5831 39.6017 27.3593 38.8041 28.1329 38.0041C28.904 37.2015 29.6852 36.409 30.4639 35.614C31.2425 34.819 32.0212 34.0239 32.8074 33.2365L35.161 30.869C35.9498 30.0841 36.7549 29.3154 37.5776 28.5645C38.4053 27.8185 39.2431 27.0826 40.1312 26.397C40.3639 26.2171 40.6973 26.2612 40.8772 26.4926C41.0281 26.6876 41.0206 26.9555 40.8772 27.1417Z",
    fill: "#E1DBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0362 30.2241C43.7972 30.5373 43.5506 30.843 43.2991 31.1437L42.9204 31.5928L42.5342 32.0343C42.0197 32.6243 41.4901 33.1992 40.9542 33.7665C39.8825 34.9024 38.7604 35.9905 37.6572 37.095L34.3362 40.3997L31.0026 43.6904C29.8931 44.7899 28.7723 45.878 27.6577 46.9712L24.3015 50.2393C22.0586 52.4143 19.8094 54.5805 17.535 56.724C17.3237 56.924 16.9891 56.914 16.7891 56.7014C16.5966 56.4976 16.6004 56.1793 16.7891 55.9781C18.9326 53.705 21.0988 51.4545 23.2738 49.2116L26.5419 45.8554C27.6351 44.7408 28.7232 43.62 29.8227 42.5105L33.1135 39.1769L36.4181 35.8559C37.5226 34.7527 38.6107 33.6319 39.7466 32.5589C40.314 32.023 40.8888 31.4921 41.4788 30.9789L41.9203 30.5927L42.3694 30.2141C42.6701 29.9625 42.9758 29.7159 43.2877 29.4769C43.5217 29.2983 43.8551 29.3436 44.0337 29.5775C44.1847 29.7738 44.1784 30.0392 44.0362 30.2241Z",
    fill: "#E1DBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3951 24.9825L55.1311 22.21L67.6364 9.53491",
    stroke: "#E1DBD2",
    strokeWidth: 1.38374,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7257 19.4425L67.6362 9.53491",
    stroke: "#E1DBD2",
    strokeWidth: 1.38374,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9448 14.7441L67.6368 9.53491",
    stroke: "#E1DBD2",
    strokeWidth: 1.38374,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7263 19.4428L46.9448 14.7444",
    stroke: "#E1DBD2",
    strokeWidth: 1.38374,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.099 28.4692L55.1311 22.2096L52.3951 24.9821L52.7259 19.4421",
    stroke: "#E1DBD2",
    strokeWidth: 1.38374,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0991 28.4695L67.6365 9.53491",
    stroke: "#E1DBD2",
    strokeWidth: 1.38374,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4767_69",
    x: 0,
    y: 0,
    width: 72.1897,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_4767_69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a8e28e3ada5f4becb83b17ef666bbb2.svg";
export { ForwardRef as ReactComponent };